import React, { useEffect, useState } from 'react'
import { getApi } from '../../../utils/services';
import { BUDGET_RECORD, FINANCIAL_YEAR_LIST } from '../../../utils/apiRoutes';
import LineColumnChart from '../../charts/linechart/LineColumnChart';
import LineChart from '../../charts/linechart/LineChart'
import { Helmet } from "react-helmet";
import Loader from '../../common/Loader';

const PlanActualBudget = () => {
    const [loader, setLoader] = useState(false);
    const [budgetRecord, setBudgetRecord] = useState([]);
    const [budgetMonths, setBudgetMonths] = useState([]);
    const [spendTrend, setSpendTrend] = useState([]);
    const [financialYearList, setFinancialYearList] = useState([])
    const [currentFinancialYearId, setCurrentFinancialYearId] = useState('')

    useEffect(() => {
        handleFinancialYearList()
    }, []);

    const handleFinancialYearList = async () => {
        try {
            setLoader(true)
            let result = await getApi(FINANCIAL_YEAR_LIST)
            setFinancialYearList(result.res.financialYear_list)
            setLoader(false)

            if (result.res.financialYear_list.length > 0) {
                const currentYear = result.res.financialYear_list[result.res.financialYear_list.length - 1];
                setCurrentFinancialYearId(currentYear.id);
                handlerBudgetChart(currentYear.id);
                handlerSpendTrendChart(currentYear.id)
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const handlerBudgetChart = async (currentFinancialYearId) => {
        try {
            setLoader(true)
            let result = await getApi(`${BUDGET_RECORD}?currentFinancialYearId=${currentFinancialYearId}`);
            const { actualBudget, planBudget, month } = result.res
            let categ = month
            let seriesData = [{
                name: 'Plan Budget',
                type: 'column',
                data: planBudget,
            },
            {
                name: 'Actual Budget',
                type: 'line',
                data: actualBudget
            }];
            setLoader(false)
            setBudgetRecord(seriesData)
            setBudgetMonths(categ)
        } catch (error) {
            console.log(error);
        }
    }

    const handlerSpendTrendChart = async (currentFinancialYearId) => {
        try {
            setLoader(true)
            let result = await getApi(`${BUDGET_RECORD}?currentFinancialYearId=${currentFinancialYearId}`);
            const { actualBudget, month } = result.res
            let categ = month
            let seriesData = [{
                name: 'Spend ',
                data: actualBudget
            }];
            setLoader(false)
            setSpendTrend(seriesData)
            setBudgetMonths(categ)
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <Helmet>
                <title>Vendor Portal || Plan vs Actual Budget</title>
            </Helmet>
            <Loader isLoading={loader} />
            <>
                <div className="row">
                    <div class="col-lg-8 col-md-7 mb-2">
                    </div>
                    <div class="col-lg-4 col-md-5 mb-2">
                        <label htmlFor="financialYear" className="form-label">Financial Year</label>
                        <select
                            id="financialYear"
                            className="form-select"
                            name="financialYear"
                            value={currentFinancialYearId}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setCurrentFinancialYearId(selectedId);
                                handlerBudgetChart(selectedId);
                                handlerSpendTrendChart(selectedId);
                            }}>
                            {financialYearList.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.CurrentFinancialYear}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-12 mb-2'>
                        <div className="row g-2">
                            <div className="col-12">
                                <div className='container-section'>
                                    <div className="card-body">
                                        <LineColumnChart
                                            title='Budget Record'
                                            data={budgetRecord}
                                            categories={budgetMonths} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className='container-section'>
                                    <div className="card-body">
                                        <LineChart
                                            title='Spend Trend'
                                            data={spendTrend}
                                            categories={budgetMonths}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default PlanActualBudget